"use client";

import {useState} from "react";
import {Button, Form, Input} from 'antd';
import {useRouter} from "@/navigation";
import s from './../signIn/auth.module.scss'
import Link from "next/link";
import { useApiMutation } from "@/lib/hook";
import {Logo} from "@/theme/ui";
import {CancelSmall, CheckSmall} from "@/theme/assets/icons";
import cn from "classnames";
import {useTranslations} from "next-intl";


export default function ForgotPassword() {
    const t = useTranslations('forgot');
    const [form] = Form.useForm();
    const passwordField = Form.useWatch('password', form);
    const [isVisible, setIsVisible] = useState(false)
    const [isVarificationCode, setIsVarificationCode] = useState(false);
    const [newPassword, setNewPassword] = useState(false);
    const [loading, setLoading] = useState(false)
    const [loadingSendCode, setLoadingSendCode] = useState(false);
    const [loadingChangeRassword, setLoadingChangeRassword] = useState(false)
    const [userId, setUserId] = useState(null);
    const [userEmail, setUserEmail] = useState('')
    const [passwordError, setPasswordError] = useState([])

    const sendEmail = useApiMutation({
        onSuccess: (client, resp, variables) => {
            setLoading(false)
            setIsVarificationCode(true)
        }
    });
    const onFinish = async (values) => {
        setLoading(true);
        setUserEmail(values)
        sendEmail.mutate({
            route: { name: 'auth.forgot.password' },
            data: values
        })
    };

    const sendCode = useApiMutation({
        onSuccess: (client, resp, variables) => {
            if (!resp.resend) {
                setUserId(resp.user_id);
                setIsVarificationCode(false)
                setNewPassword(true)
                setLoadingSendCode(false)
            }
        }
    });

    const onFinishVarification = async (values) => {
        setLoadingSendCode(true);
        sendCode.mutate({
            route: { name: 'auth.check.code' },
            data: values
        })
    };
    const { replace } = useRouter();
    const update = useApiMutation({
        onSuccess: (resp) => {
            replace('/sign-in')
        }
    });

    const resendCode = () => {
        sendCode.mutate({
            route: { name: 'auth.forgot.password' },
            data: {
                ...userEmail,
                resend: true
            }
        })
    }

    const changePassword = async (values) => {
        if (values.password.length < 8) {
            setPasswordError([...passwordError, 'num'])
        } else if (!(/[A-Z]/.test(values.password))) {
            setPasswordError([...passwordError, 'uppercase'])
        } else if (!(/[0-9]/.test(values.password))) {
            setPasswordError([...passwordError, 'number'])
        } else {
            setLoadingChangeRassword(true)
            update.mutate({
                route: { name: 'auth.change.password' },
                data: {
                    ...values,
                    user_id: userId,
                }
            })
            setLoadingChangeRassword(false)
        }
    }

    const renderPasswordTips = () => {
        return (
            <>
                {isVisible && <div className={s.warnings}>
                    <div className={cn(s.item, s.item_characters, {
                        [s.green]: !!passwordField && passwordField.length >= 8,
                        [s.red]: passwordError.includes('num')
                    })}>
                        {(!!passwordField && passwordField.length >= 8) ? <CheckSmall /> : <CancelSmall />}
                        {t('validations.characters')}
                    </div>
                    <div className={cn(s.item, s.item_characters, {
                        [s.green]: !!passwordField && (/[A-Z]/.test(passwordField)),
                        [s.red]: passwordError.includes('uppercase')
                    })}>
                        {(!!passwordField && (/[A-Z]/.test(passwordField))) ? <CheckSmall /> : <CancelSmall />}
                        {t('validations.uppercase')}
                    </div>
                    <div className={cn(s.item, s.item_characters, {
                        [s.green]: !!passwordField && (/[0-9]/.test(passwordField)),
                        [s.red]: passwordError.includes('number')
                    })}>
                        {(!!passwordField && (/[0-9]/.test(passwordField))) ? <CheckSmall /> : <CancelSmall />}
                        {t('validations.number')}
                    </div>
                </div>}
            </>

        )
    }

    const variablesHandler = (value) => {
        if (!!value.password) {
            setIsVisible(true)
            if (value.password.length < 8) {
                let arr = passwordError.filter(el => el === 'num')
                setPasswordError(arr)
            } else if (/[A-Z]/.test(value.password)) {
                let arr = passwordError.filter(el => el === 'uppercase')
                setPasswordError(arr)
            } else if (/[0-9]/.test(value.password)) {
                let arr = passwordError.filter(el => el === 'number')
                setPasswordError(arr)
            }
        } else {
            setIsVisible(false)
        }
    }

    const setVisibleHandler = () => {
        if (!isVisible) {
            setIsVisible(true)
        }
    }

    return(
        <>
            <div className={s.main_wrapper}>
                <div className={s.head_logo}><Logo /></div>
                <div className={s.sign_up_content}>

                    {!isVarificationCode && !newPassword && <>
                        <h2>{t('one_form.title')}</h2>
                        <p className={s.description}>{t('one_form.description')}</p>
                        <div className={s.content}>
                            <Form
                                name='forgot-password'
                                style={{
                                    maxWidth: 514,
                                    width: '100%'
                                }}
                                onFinish={onFinish}
                            >
                                <Form.Item
                                    label={t('one_form.label')}
                                    name="email"
                                    rules={[
                                        {
                                            required: true,
                                            message: t('one_form.validations.email'),
                                        },
                                    ]}
                                >
                                    <Input placeholder={t('one_form.email_placeholder')} />
                                </Form.Item>
                                <Button
                                    loading={loading}
                                    type="default"
                                    className={s.auth}
                                    style={{maxWidth: '100%', width: '100%', marginTop: 0}}
                                    htmlType="submit"
                                >
                                    {t('one_form.send_email')}
                                </Button>
                            </Form>
                            <div className="">
                                {t('one_form.remember')} <Link style={{color: '#DB3333'}} href={'/sign-in'}>{t('one_form.login')}</Link>
                            </div>
                        </div>
                    </>}
                    {isVarificationCode && !newPassword && <>
                        <h2>{t('two_form.title')}</h2>
                        <div className={s.content}>
                            <Form
                                name='varification'
                                style={{
                                    maxWidth: 514,
                                    width: '100%'
                                }}
                                onFinish={onFinishVarification}
                            >
                                <Form.Item
                                    label={t('two_form.label')}
                                    name="code"
                                    style={{marginBottom: '32px'}}
                                    rules={[
                                        {
                                            required: true,
                                            message: t('two_form.validations.code'),
                                        },
                                    ]}
                                >
                                    <Input placeholder={t('two_form.code_placeholder')} />
                                </Form.Item>
                                <Button
                                    loading={loadingSendCode}
                                    type="default"
                                    className={s.auth}
                                    style={{maxWidth: '100%', width: '100%', marginTop: 0}}
                                    htmlType="submit"
                                >
                                    {t('two_form.confirm_code')}
                                </Button>
                            </Form>
                            <div className="">
                                {t('two_form.didnt_receive')}<Button
                                type="link"
                                className={'link'}
                                onClick={resendCode}
                            > {t('two_form.resend')}</Button>
                            </div>
                        </div>
                    </>}
                    {newPassword && !isVarificationCode && (
                        <>
                            <h2>{t('three_form.title')}</h2>
                            <div className={s.content}>
                                <Form
                                    form={form}
                                    name='newPassword'
                                    style={{
                                        maxWidth: 514,
                                        width: '100%'
                                    }}
                                    onValuesChange={variablesHandler}
                                    onFinish={changePassword}
                                >
                                    <Form.Item
                                        label={t('three_form.label')}
                                        name="password"
                                        style={{marginBottom: 0}}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('three_form.validations.password'),
                                            },
                                        ]}
                                    >
                                        <Input.Password
                                            placeholder={t('three_form.password_placeholder')}
                                            onFocus={setVisibleHandler}
                                        />
                                    </Form.Item>
                                    {renderPasswordTips()}
                                    <Button
                                        loading={loadingChangeRassword}
                                        type="default"
                                        className={s.auth}
                                        style={{maxWidth: '100%', width: '100%', marginTop: '20px'}}
                                        htmlType="submit"
                                    >
                                        {t('three_form.reset')}
                                    </Button>
                                </Form>

                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    )
}